import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface SummerPass {
  student_name: string;
  student_email: string;
}

const summerPass: Module<SummerPass, RootState> = {
  namespaced: true,
  state: {
    student_name: '',
    student_email: '',
  },
  getters: {},
  mutations: {
    setValue(state: SummerPass, value: SummerPass): void {
      Object.assign(state, value);
    },
  },
};

export default summerPass;
